<section class="bank-journey" role="region" aria-label="Jornada nos bancos">
  <!-- Card 3752: no modo bancos o cabeçalho do deal já mostra o resumo por etapa; aqui ficam só as duas vistas. -->
  <div class="bank-journey__views" role="tablist" aria-label="Vista dos bancos">
    <button
      type="button"
      role="tab"
      class="bank-journey__view"
      [class.bank-journey__view--active]="view() === 'board'"
      [attr.aria-selected]="view() === 'board'"
      aria-controls="bank-journey-view"
      (click)="view.set('board')">
      <i class="pi pi-th-large" aria-hidden="true"></i>
      Quadro
    </button>
    <button
      type="button"
      role="tab"
      class="bank-journey__view"
      [class.bank-journey__view--active]="view() === 'list'"
      [attr.aria-selected]="view() === 'list'"
      aria-controls="bank-journey-view"
      (click)="view.set('list')">
      <i class="pi pi-list" aria-hidden="true"></i>
      Lista
    </button>
    <span class="bank-journey__hint">{{ hint() }}</span>
  </div>

  @if (view() === 'board') {
    <div id="bank-journey-view" role="tabpanel" class="bank-journey__board">
      <!-- Mesmo `app-kanban-board` do quadro de deals, sem arrasto: a etapa do banco muda no pipe de crédito. -->
      <app-kanban-board
        [columns]="columns"
        [activeItemsOf]="cardsOf"
        [countOf]="countOf"
        [totalsOf]="totalsOf"
        [isColumnEmpty]="isColumnEmpty"
        [minimizedColumnIds]="minimizedColumnIds()"
        [hasManyColumns]="true"
        [fillWidth]="true"
        [summaryMinimized]="summaryMinimized()"
        [dragDisabled]="true"
        (columnMinimizeToggle)="toggleColumn($event.columnId)"
        (summaryToggle)="summaryMinimized.set(!summaryMinimized())">
        <ng-template #kanbanCard let-card>
          <ng-container *ngTemplateOutlet="journeyCard; context: { $implicit: card }" />
        </ng-template>
      </app-kanban-board>
    </div>
  } @else {
    <div id="bank-journey-view" role="tabpanel" class="bank-list">
      <table class="bank-list__table">
        <thead>
          <tr>
            <th>Banco</th>
            @if (showDeal()) {
              <th>Deal</th>
            }
            <th>Operação</th>
            <th class="bank-list__num">Valor</th>
            <th>Etapa</th>
            <th>Desde</th>
            <th class="bank-list__num">Comentários</th>
          </tr>
        </thead>
        <tbody>
          @for (card of sortedCards(); track card.pipelineDealId) {
            <tr
              class="bank-list__row"
              tabindex="0"
              [title]="'Ver os comentários do ' + (card.bankName || 'banco')"
              (click)="store.openComments(card)"
              (keydown.enter)="store.openComments(card)">
              <td>
                <span class="bank-list__bank">
                  @if (card.bankCompensationCode) {
                    <app-bank-logo [code]="card.bankCompensationCode" [maxWidth]="18" />
                  }
                  {{ card.bankName || 'Banco não informado' }}
                </span>
              </td>
              @if (showDeal()) {
                <td>
                  <ng-container *ngTemplateOutlet="dealLink; context: { $implicit: card }" />
                </td>
              }
              <td>{{ (card.operationType | vaulttranslateEnum: 'LoanOperationType') || '-' }}</td>
              <td class="bank-list__num">
                {{ card.currencyCode }} {{ card.value | vaultFormatCurrency: 2 }}
              </td>
              <td>
                <span
                  class="bank-list__stage"
                  [class]="'bank-list__stage bank-list__stage--' + tones[card.stage]">
                  {{ stageLabel(card.stage) }}
                </span>
              </td>
              <td>{{ card.stageSince | vaultDate }}</td>
              <td class="bank-list__num">
                <span class="bank-list__comments">
                  <i class="pi pi-comment" aria-hidden="true"></i>
                  {{ card.commentCount }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>

<!-- Cartão no padrão do `.pipeline-card` do crédito: 200px, raio 6px, sombra leve, fontes de 10-12px. Dentro do
     deal, sem o número e a empresa (todos os bancos são do mesmo deal); no Meus deals (`showDeal`, card 3765), com
     eles e o link para o deal. -->
<ng-template #journeyCard let-card>
  <article
    class="journey-card"
    role="button"
    tabindex="0"
    [title]="'Ver os comentários do ' + (card.bankName || 'banco')"
    (click)="store.openComments(card)"
    (keydown.enter)="store.openComments(card)">
    <header class="journey-card__head">
      @if (card.bankCompensationCode) {
        <app-bank-logo [code]="card.bankCompensationCode" [maxWidth]="18" />
      }
      <span class="journey-card__bank">{{ card.bankName || 'Banco não informado' }}</span>
    </header>

    @if (showDeal()) {
      <ng-container *ngTemplateOutlet="dealLink; context: { $implicit: card }" />
    }

    <span class="journey-card__type">
      {{ (card.operationType | vaulttranslateEnum: 'LoanOperationType') || '-' }}
    </span>
    <span class="journey-card__value">
      {{ card.currencyCode }} <strong>{{ card.value | vaultFormatCurrency: 2 }}</strong>
    </span>

    <footer class="journey-card__foot">
      <span>desde {{ card.stageSince | vaultDate }}</span>
      <span
        class="journey-card__comments"
        [title]="card.commentCount === 1 ? '1 comentário' : card.commentCount + ' comentários'">
        <i class="pi pi-comment" aria-hidden="true"></i>
        {{ card.commentCount }}
      </span>
    </footer>
  </article>
</ng-template>

<!-- Empresa e número do deal, com link para a tela do deal (card 3765). `stopPropagation`: o clique no cartão ou na
     linha abre os comentários; no link, abre o deal. -->
<ng-template #dealLink let-card>
  <a
    class="journey-deal"
    [routerLink]="['/dashboard/commercial/my-deals', card.partnerDealId]"
    [queryParams]="{ tab: 'banks' }"
    [title]="'Abrir o deal de ' + card.companyName"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()">
    <i class="pi pi-building" aria-hidden="true"></i>
    <span class="journey-deal__name">{{ card.companyName }}</span>
    <span class="journey-deal__number">#{{ card.partnerDealSequentialId }}</span>
  </a>
</ng-template>
